<assessment-report
  [dialogMode]="true"
  [showScoreMedian]="true"
  [assessmentSettings]="course.information?.assessment"
  [assessmentResult]="assessmentResult"
  [courseId]="course.id"
  (onShowSessionLogs)="showSessionLogs()"
  (onClose)="close()">
</assessment-report>
